import React from 'react';
import { moment, momentFormats } from '~/vendorConfigs/moment';

interface RiskBandElevationProps {
    metadata: PatientMetadataType;
}

export function RiskBandElevation({ metadata }: RiskBandElevationProps) {
    if (metadata?.RiskBandElevationDate) {
        const dt = moment(metadata.RiskBandElevationDate);
        if (dt.isSameOrAfter(moment().subtract(30, 'days'))) {
            return (
                <i
                    className="fa-solid fa-arrow-up text-danger ms-1"
                    title={`Risk band increased on ${dt.format(momentFormats.DATE)}`}
                />
            );
        }
    }
    return null;
}
